// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import styled from 'styled-components'
import { UpdatedLabeledInputWrapper } from 'components/Form/updated/UpdatedLabeledInput/styles'

export const UpdatedLabeledRadioGroupWrapper = styled(UpdatedLabeledInputWrapper)`
  > .radio-group {
    grid-area: input;
    -ms-grid-column: 1;
    -ms-grid-column-span: 2;
    -ms-grid-row: 3;
  }

  // makes the radio buttons about as tall as the text inputs
  &.radio-size-lg {
    > .radio-group {
      font-size: 1.3em;
    }
  }

  &.radios-fill-container {
    > .radio-group {
      width: 100%;
    }
  }
`
